import styled from 'styled-components';
import { Flex } from '#atoms';

type LicenseProps = {
  title: string;
  description: string;
  handleChoose: () => void;
};

export default function License({
  description,
  title,
  handleChoose
}: LicenseProps) {
  return (
    <Wrapper align="center" justify="space-between">
      <Flex direction="column">
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Flex>
      <Choose onClick={handleChoose}>선택</Choose>
    </Wrapper>
  );
}

const Wrapper = styled(Flex)``;
const Title = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray15};
`;
const Description = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.gray100};
`;
const Choose = styled.button`
  cursor: pointer;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.palette.brand400};
  color: white;
  border-radius: 8px;
`;
